import { render, staticRenderFns } from "./tenStocks.vue?vue&type=template&id=27a5140b&scoped=true&"
import script from "./tenStocks.vue?vue&type=script&lang=js&"
export * from "./tenStocks.vue?vue&type=script&lang=js&"
import style0 from "./tenStocks.vue?vue&type=style&index=0&id=27a5140b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5140b",
  null
  
)

export default component.exports